import { defineComponent } from "vue";
import { COMPONENT_NAME, SVG } from "./attributes";
import { SvgAttribute } from "@/shared/constants/constants";
import { RoutesName } from "@/shared/constants/enums";

export default defineComponent({
    name: COMPONENT_NAME,
    data() {
        return {
            userRepo: this.$projectServices.userRepo,
        };
    },
    computed: { 
        shouldShowBanner(): boolean {
            return !this.userRepo.isVerified;
        },
        displayedIcons(): SvgAttribute {
            return SVG;
          },
    },
    methods: {
        goToSettings(): void {
            this.$router.push({ name: RoutesName.settings }); 
        },
        goToVerification(): void {
            this.$router.push({ name: RoutesName.verification }); 
        },
    },
});
